import { cn } from '../../utils/cn';

const COLORS = {
  neutral: 'bg-neutral-100 text-neutral-700 ring-neutral-200',
  blue: 'bg-primary-50 text-primary-700 ring-primary-200',
  green: 'bg-success-50 text-success-700 ring-success-200',
  red: 'bg-danger-50 text-danger-700 ring-danger-200',
  yellow: 'bg-warning-50 text-warning-700 ring-warning-200',
  amber: 'bg-amber-50 text-amber-700 ring-amber-200',
  orange: 'bg-orange-50 text-orange-700 ring-orange-200',
  purple: 'bg-purple-50 text-purple-700 ring-purple-200',
  teal: 'bg-teal-50 text-teal-700 ring-teal-200',
};

export default function Badge({ color = 'neutral', size = 'md', className, children, ...rest }) {
  const sizes = {
    sm: 'text-[10px] px-1.5 py-0.5',
    md: 'text-xs px-2 py-0.5',
    lg: 'text-sm px-2.5 py-1',
  };
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium ring-1 ring-inset whitespace-nowrap',
        COLORS[color] || COLORS.neutral,
        sizes[size],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
